{% block swag_cms_extensions_form_editor_settings_field_type_footer %}
    <div class="swag-cms-extensions-form-editor-settings-field-type-footer">
        {% block swag_cms_extensions_form_editor_settings_field_type_footer_required %}
            <mt-switch
                v-model="required"
                :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.requiredFieldLabel')"
            />
        {% endblock %}

        {% block swag_cms_extensions_form_editor_settings_field_type_footer_error_message %}
            <mt-text-field
                v-if="required"
                v-model="errorMessage"
                :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.errorMessageFieldLabel')"
            />
        {% endblock %}
    </div>
{% endblock %}
